import React from "react";
import PortfolioTabsContainer from "../components/PortfolioSections/PortfolioTabsContainer";
import SectionTitle from "../components/Utilities/SectionTitle";

const PortfolioLayout = () => {
  return (
    <>
      <section className="portfolio-area section-gap" id="portfolio">
        <div className="container">
          <SectionTitle sectionTitleText="Our Projects" />
          <PortfolioTabsContainer />
        </div>
      </section>
    </>
  );
};

export default PortfolioLayout;
